import { AbstractControl } from '@angular/forms';
export function isMatchingControl(control1: AbstractControl) {
  return (control: AbstractControl): Record<string, any> | null => {
    const forbidden = control.value !== control1.value;
    return forbidden ? { mismatch: true } : null;
  };
}

export function maxErrorKey(max: number, errorKey = 'max'): any  {
  return (control) => {
    if ((control.value === null || control.value.length === 0) || max === null) {
      return null;
    }
    const value = parseFloat(control.value);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    return !isNaN(value) && value > max ? { [errorKey]: { [errorKey]: max, 'actual': control.value } } : null;
  };
}
